<mat-spinner *ngIf="!init" color="primary" diameter="48"></mat-spinner>
<div *ngIf="init" class="container">
  <ex-edit-adjustment
    [project]="project"
    [subproject]="adjustment"
    [client]="true"
    [disabled]="adjustment.id != null"
  ></ex-edit-adjustment>

  <div class="strong form-sub-title">Oorspronkelijke opdracht</div>
  <mat-card class="mat-elevation-z0">
    <adjustment-project-summary
      [subproject]="subProject"
      [project]="project"
      [client]="true"
    ></adjustment-project-summary>
  </mat-card>
  <div *ngIf="adjustment.id == null" class="upper-space flexer text-right">
    <p *ngIf="subProject.type !== 'Repo'" class="italics-text text-right">
      Er wordt een offerte en ontwerp opgesteld voor
      {{ getFormDisplayDemonstrative() }} {{ getFormDisplayNameLowerCase() }}.
    </p>
    <p *ngIf="subProject.type === 'Repo'" class="italics-text text-right">
      Er wordt eerst een offerte opgemaakt.
    </p>
    <div class="d-flex">
      <button
        class="cancel-button"
        type="button"
        mat-button
        (click)="cancelProject()"
      >
        Annuleren
      </button>
      <div class="flexer text-right">
        <button
          class="button"
          type="button"
          mat-button
          (click)="doSubmitProject()"
        >
          Aanvraag indienen
        </button>
      </div>
    </div>
  </div>
</div>
